import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Switch } from '../ui/switch';
import { Slider } from '../ui/slider';
import { useApp } from '../../context/AppContext';
import { CATEGORIES, COUNTRIES } from '../../data/constants';
import { LOCALES } from '../../lib/i18n';

const Label = ({ children }) => <label className="text-xs uppercase tracking-wider font-bold text-[#7A7468] mb-2 block">{children}</label>;

const CategoryFilter = ({ value, onChange }) => {
  const { t, lang } = useApp();
  const items = [{ id: 'all', label: t('mkt.all') }, ...CATEGORIES.map((c) => ({ id: c.id, label: c.name[lang] || c.name.en }))];
  return (
    <div>
      <Label>{t('mkt.category')}</Label>
      <div className="space-y-1.5">
        {items.map((c) => (
          <button key={c.id} onClick={() => onChange(c.id)} data-testid={`filter-cat-${c.id}`} className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${value === c.id ? 'bg-[#0F8B5C] text-white font-semibold' : 'hover:bg-[#FAF7F2] text-[#3F3A30]'}`}>{c.label}</button>
        ))}
      </div>
    </div>
  );
};

export const Filters = ({ filters, setFilters, onReset }) => {
  const { t, lang } = useApp();
  const update = (patch) => setFilters((f) => ({ ...f, ...patch }));
  return (
    <div className="space-y-6" data-testid="marketplace-filters">
      <CategoryFilter value={filters.cat} onChange={(cat) => update({ cat })} />
      <div>
        <Label>{t('mkt.country')}</Label>
        <Select value={filters.country} onValueChange={(country) => update({ country })}>
          <SelectTrigger className="bg-white" data-testid="filter-country-select"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value="all">{t('mkt.allCountries')}</SelectItem>
            {COUNTRIES.map((c) => <SelectItem key={c.code} value={c.code}>{c.flag} {c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>{t('mkt.price')} (CFA)</Label>
        <Slider value={filters.price} onValueChange={(price) => update({ price })} min={0} max={2000000} step={10000} data-testid="filter-price-slider" />
        <div className="flex justify-between text-xs text-[#3F3A30] mt-2 font-medium">
          <span>{filters.price[0].toLocaleString(LOCALES[lang])}</span>
          <span>{filters.price[1].toLocaleString(LOCALES[lang])}+</span>
        </div>
      </div>
      <div className="flex items-center justify-between p-3 rounded-xl bg-[#FAF7F2]">
        <label className="text-sm font-medium text-[#1A1A1A] cursor-pointer">{t('mkt.diaspora')}</label>
        <Switch checked={filters.diaspora} onCheckedChange={(diaspora) => update({ diaspora })} data-testid="filter-diaspora-switch" />
      </div>
      <Button variant="outline" onClick={onReset} className="w-full" data-testid="filter-reset-button"><X className="w-4 h-4 mr-2" /> {t('mkt.reset')}</Button>
    </div>
  );
};
